module.exports = __webpack_public_path__ + "img/u46.1368744d.png";